DJ.addBehavior('header', '.header', {
    attach: function(context, settings, behavior) {

      let prevScrollPos = window.scrollY;
      let headerHeight = jQuery(this).height();

      // Keep the fixed header below the admin toolbars (Gin toolbar and its
      // secondary bar). The secondary bar scrolls away, so the static
      // --drupal-displace-offset-top cannot be used: measure what is visible.
      // Elements inside a side tray (vertical toolbar on small screens) are
      // skipped: Gin flags its menu there with data-offset-top as well.
      // Horizontally, the header follows the body shift applied by an open
      // side tray: depending on the width, the tray either pushes the page or
      // overlays it, which the displace left/right offsets do not tell apart.
      const updateAdminOffset = function() {
        let offset = 0;
        document.querySelectorAll('[data-offset-top]').forEach(function(element) {
          if (element.closest('[data-offset-left], [data-offset-right]')) {
            return;
          }
          const rect = element.getBoundingClientRect();
          if (rect.height > 0) {
            offset = Math.max(offset, rect.bottom);
          }
        });
        const bodyStyle = window.getComputedStyle(document.body);
        const rootStyle = document.documentElement.style;
        rootStyle.setProperty('--biogaran-admin-offset-top', Math.round(offset) + 'px');
        rootStyle.setProperty('--biogaran-admin-offset-left', (parseFloat(bodyStyle.marginLeft) + parseFloat(bodyStyle.paddingLeft)) + 'px');
        rootStyle.setProperty('--biogaran-admin-offset-right', (parseFloat(bodyStyle.marginRight) + parseFloat(bodyStyle.paddingRight)) + 'px');
      };

      if (document.querySelector('[data-offset-top]')) {
        updateAdminOffset();
        window.addEventListener('scroll', updateAdminOffset, { passive: true });
        window.addEventListener('resize', updateAdminOffset);
        document.body.addEventListener('transitionend', updateAdminOffset);
        jQuery(document).on('drupalViewportOffsetChange', updateAdminOffset);
      }

      window.addEventListener('scroll', function() {
        const currentScrollPos = window.scrollY;

        if (currentScrollPos > headerHeight && prevScrollPos < currentScrollPos) {
          document.querySelector('.header').classList.add('hide');
         } else {
          document.querySelector('.header').classList.remove('hide');
        }
        prevScrollPos = currentScrollPos;
      });

    },

    detach: function(context, settings) {}
});
